import { User } from '../module/private/user/entity/user.model';
import { mConstants } from './constants';

function getBreadCrumbs(crumbs: string[], spacing = ' - ') {
  let whole = '';

  crumbs.forEach((x) => (whole = whole.concat(`${x}${spacing}`)));

  if (whole.length === 0) {
    return whole;
  }

  return whole.substring(0, whole.length - spacing.length);
}

function getExtension(imageName: string) {
  return imageName.split('.').pop();
}

function getPublicFileAbsolutePath(filePath: string) {
  return `${mConstants.API_URL}${mConstants.FILE_DOWNLOAD_PATH}public/${filePath}`;
}

function formatCurrency(value: number) {
  let formatter = new Intl.NumberFormat('mn-MN', {
    style: 'currency',
    currency: 'MNT',
  });

  let formatted = formatter.format(value);

  return formatted.substring(3, formatted.length) + ' ₮';
}

function formatListItemUser(user?: User) {
  if (!user) {
    return '';
  }

  return `${user.username} - ${user.lastName ?? 'N/A'} ${
    user.firstName ?? 'N/A'
  }`;
}

export const mUtils = {
  getBreadCrumbs,
  getExtension,
  formatCurrency,
  getPublicFileAbsolutePath,
  formatListItemUser,
};
